function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/**
 * Extracts a specific property of the form from all fields into one object
 * @param  {Record} fields - form fields
 * @param  {string} property - property to extract
 * @return {Object} collection of properies from each field, and their values
 */
export default function extractPropertyFromFields(fields, property) {
  return (fields || []).reduce(function (acc, properties, field) {
    var fieldValue = properties ? properties.get(property) : null;
    if (fieldValue === undefined) {
      fieldValue = null;
    }
    return _objectSpread({}, acc, _defineProperty({}, field, fieldValue));
  }, {});
}